export default __webpack_public_path__ + "static/media/cardGroup.377a562b.less";